export const SET_PROFILE = "SET_PROFILE";
export const SET_PROFILE_ID = "SET_PROFILE_ID";
export const SET_ACCOUNT_ACCESS = "SET_ACCOUNT_ACCESS";
export const SET_NO_ACCOUNTS = "SET_NO_ACCOUNTS";
export const RESET_PROFILE = "RESET_PROFILE";
export const SET_PROFILE_PICTURE = "SET_PROFILE_PICTURE";
export const SET_SMS_SETTING = "SET_SMS_SETTING";
export const LOG_OUT = "LOG_OUT";
